import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgChevronLeft = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.429 21.821a1.315 1.315 0 1 1-1.86 1.86l-8.75-8.75a1.312 1.312 0 0 1 0-1.86l8.75-8.75a1.315 1.315 0 1 1 1.86 1.86L10.609 14l7.82 7.821Z" />
  </svg>
);
export default SvgChevronLeft;
